import React from "react";
import Image from "next/image";
import Link from "next/link";
import { formatDate } from "@/utils/formatDate";

const RelatedNewsCard = ({ latestData }: any) => {
  return (
    <div className="flex flex-col gap-3 rounded-lg bg-gray-100 shadow-lg drop-shadow">
      <Image
        src={latestData?.featured_image?.url}
        objectFit="fill"
        width={400}
        height={280}
        className="h-28 max-h-28 min-h-28 w-full rounded-t-lg object-fill object-center"
        alt={latestData?.featured_image?.url ?? "default news"}
      />
      <div className="flex h-full flex-col justify-between gap-2 px-2 pb-2">
        <div className="space-y-1">
          <Link href={`/news/${latestData?.url}`}>
            <h2 className="line-clamp-1 font-poppins text-sm font-semibold leading-4 tracking-tight">
              {latestData?.name}
            </h2>
          </Link>
          <p className="mt-3 line-clamp-2 font-montserrat text-xs leading-tight">
            {latestData?.excerpt}
          </p>
        </div>

        <small className="mt-1 text-right text-xs ">
          {formatDate(latestData?.updatedAt)}
        </small>
      </div>
    </div>
  );
};

export default RelatedNewsCard;